import React, { useState } from "react";

const SendBackToReviewerModal = ({
  isOpen,
  onClose,
  onConfirm,
  licenceRefNumber,
}) => {
  const [reason, setReason] = useState("");
  const [comments, setComments] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) {
      alert("Please provide a reason");
      return;
    }

    setSubmitting(true);
    try {
      await onConfirm({
        reason: reason.trim(),
        comments: comments.trim() || undefined,
      });
      // Reset form
      setReason("");
      setComments("");
      onClose();
    } catch (error) {
      console.error("Error sending back to reviewer:", error);
      alert("Failed to send back to reviewer. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          Send Back to Reviewer
        </h2>

        <p className="text-sm text-gray-600 mb-4">
          This will send the licence request <strong>{licenceRefNumber}</strong>{" "}
          back to the reviewer for additional review.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Reason <span className="text-red-500">*</span>
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-400"
              rows="4"
              placeholder="Please provide a reason for sending this back to the reviewer..."
              required
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Additional Comments (Optional)
            </label>
            <textarea
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-400"
              rows="3"
              placeholder="Any additional comments or instructions..."
            />
          </div>

          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={submitting}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting || !reason.trim()}
              className="px-4 py-2 text-sm font-medium text-white bg-emerald-400 rounded-lg hover:bg-emerald-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {submitting ? "Sending..." : "Send Back"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SendBackToReviewerModal;
